import React, {Component, PropTypes} from 'react'
import Icon from './Icon'
import style from './Rating.less'

function mapCount(fnc, count) {
    var result = []
    for (var i = 0 ; i < count ; i++) {
        result.push(fnc(i))
    }
    return result
}

class Rating extends Component {
    static PropTypes = {
        label: PropTypes.string,
        range: PropTypes.number,
        value: PropTypes.number,
        onChange: PropTypes.func
    }

    static defaultProps = {
        range: 5
    }

    _rate(event, score) {
        const {onChange} = this.props

        event.preventDefault()
        onChange(score)
    }

    render() {
        const {label, range, value, onChange} = this.props

        return (
            <div className={style.default}>
                <div className={style.score}>
                    <strong>{value && Math.floor(value * 10) / 10 || '---'}</strong>
                    <small>{label}</small>
                </div>
                <div className={style.body}>
                    {onChange && mapCount((rangeIndex) => (
                        <a
                            key={rangeIndex}
                            href=''
                            onClick={(e) => this._rate(e, rangeIndex + 1)}>
                            <Icon icon='star' size='sm' active={rangeIndex + 1 <= value} />
                        </a>
                    ), range)}
                    {!onChange && mapCount((rangeIndex) => (
                        <Icon key={rangeIndex} icon='star' size='sm' active={rangeIndex + 1 <= value} />
                    ), range)}
                </div>
            </div>
        )
    }
}

export default Rating


// WEBPACK FOOTER //
// ./lib/core/components/Rating.js